"use strict";

import { Component } from "@angular/core";
import { Router, ActivatedRoute, Params } from "@angular/router";
// import { Constants } from "../constants/companyAddress";
import { CompanyService } from "./../services/company.service";

@Component({
  selector: "home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.css"],
})
export class HomeComponent {
  companyData: any = [];
  date: any;
  day: any;
  time: any;
  showInvoiceOption: boolean = true;
  upcomingInvoice: any;
  newinvoice: any;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private companyService: CompanyService
  ) {
    setInterval(() => {
      this.newTime();
    }, 1);
  }

  ngOnInit() {
    if (!localStorage.getItem("upcomingInvoice")) {
      localStorage.setItem("upcomingInvoice", "0001");
    } else {
      //  this.upcomingInvoice = localStorage.getItem('upcomingInvoice')
    }

    // this.companyData = Constants.companyAddress();

    this.getPersentTime();
    this.getAllCompanies();
  }

  createBill = function (data) {
    this.router.navigate(["/bill"], { queryParams: { company: data } });

    // this.router.navigate(["/bill"], { queryParams: { company: "AVCL" } });
  };

  getPersentTime = function () {
    this.date =
      new Date().getDate() +
      "/" +
      (new Date().getMonth() + 1) +
      "/" +
      new Date().getFullYear();
    this.day = new Date().getDay();
    //if(this.day){
    switch (this.day) {
      case 1:
        this.day = "Monday";
        break;
      case 2:
        this.day = "Tuesday";
        break;
      case 3:
        this.day = "Wednesday";
        break;
      case 4:
        this.day = "Thursday";
        break;
      case 5:
        this.day = "Friday";
        break;
      case 6:
        this.day = "Saturday";
        break;
      default:
        this.day = "Sunday";
    }
    //}
  };

  newTime = function () {
    let h: any = new Date().getHours();
    if (h < 10) {
      h = "0" + h;
    }
    let m: any = new Date().getMinutes();
    if (m < 10) {
      m = "0" + m;
    }
    let s: any = new Date().getSeconds();
    if (s < 10) {
      s = "0" + s;
    }

    let ampm = h >= 12 ? "pm" : "am";
    h = h % 12;
    h = h ? h : 12;

    this.time = h + ":" + m + ":" + s + " " + ampm;
  };

  updateInvoice = function () {
    this.showInvoiceOption = false;
  };

  changeInvoice = function (newInvoice) {
    if (newInvoice) {
      localStorage.setItem("upcomingInvoice", newInvoice.toString());
      this.upcomingInvoice = localStorage.getItem("upcomingInvoice");
      this.showInvoiceOption = true;
    } else {
      this.showInvoiceOption = true;
    }
  };

  companyDetails = function () {
    this.router.navigate(["/company"]);
  };

  billDetails = function () {
    this.router.navigate(["/detail"]);
  };

  scrapBill = function () {
    this.router.navigate(["/scrap"]);
  };

  getAllCompanies() {
    this.companyService.getCompany("all").subscribe(
      (res: any) => {
        console.log(res);
        this.companyData = res.data;
      },
      (err) => {
        console.log(err);
      }
    );
  }

  getCompanyDetails = function () { };
}



// WEBPACK FOOTER //
// ./src/app/home/home.component.ts